import { render, staticRenderFns } from "./AffiliateCrgModal.vue?vue&type=template&id=4f35c5c2&"
import script from "./AffiliateCrgModal.vue?vue&type=script&lang=js&"
export * from "./AffiliateCrgModal.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateCrgModal.vue?vue&type=style&index=0&id=4f35c5c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports